<script setup lang="ts">
    import { computed } from 'vue';

    const props = defineProps({
        timestamp: {
            type: Date,
            required: true,
        },
    });

    const datetime = computed(() => {
        return props.timestamp.toISOString();
    });

    const time = computed(() => {
        return props.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    });
</script>

<template>
    <time class="chat-time" :datetime="datetime">{{ time }}</time>
</template>
